import React from 'react'
import { Modal } from 'components/common'
import Table from  'components/table'


class  AbsenteeismDetails extends React.Component {

	render() {
		const { coursemodule_id, entity_code } = this.props;
		const params = {
			courseaction_id: hp.store.courseaction_id,
			module_id: coursemodule_id,
			entity_code: entity_code,
			react: 1
		};
		const url = "/courseactions/absenteeism_details.json".urlify(params);
		return (
			<div>
				<Table url={url}
				className="table regular_table no-margin-bottom"
				/>
			</div>
		);
	}
}

export class HorizontalTable extends React.Component {
	onExpand(module) {
		if (!module.eval_params) {
			http.get('/courseaction/absenteeism_evaluation_params_details.json',
				{
					courseaction_id: hp.store.courseaction_id,
					coursemodule_id: module.coursemodule_id,
					level: module.level
				},
				(response, suceess) => {
					module.eval_params = {
						expanded: true,
						params: response.params,
						evals: response.evals
					}
					this.forceUpdate();
				}
			);
		}
		else {
			module.eval_params.expanded = !module.eval_params.expanded;
			this.forceUpdate();
		}
	}

	showParamsDetails(coursemodule_id, entity_code){
		http.get('/courseactions/absenteeism_details.ajax',
			{
				courseaction_id: hp.store.courseaction_id,
				module_id: coursemodule_id,
				entity_code: entity_code
			},
			(response, suceess) => {}
		);
	}


	render() {
		// percorrer todos os modulos
		const table_body = hp.store.modules.map((module, i) => {
			// percorrer todos os formandos
			const tds = hp.store.trainees.map((trainee, j) => {
				const evall = module.trainees ? module.trainees[trainee.entity_code] : null;
				var assid = "-";
				var just = "-";
				var injust = "-";
				var search = "";
				const params = {
					title: __('attrs_details')
				}

				if(hp.store.assids && hp.store.assids[module.coursemodule_id] && hp.store.assids[module.coursemodule_id][trainee.entity_code]){
					const value = hp.store.assids[module.coursemodule_id][trainee.entity_code];
					if(value && value.assid >= 0){
						assid = value.assid + "% ";
						search =
							<em className="la la-search-plus pointer" onClick={() => Modal.show(
								<AbsenteeismDetails
									coursemodule_id={module.coursemodule_id}
									entity_code={trainee.entity_code}
								/>,
								params
								)}
								title={__('attrs_details_attendance')}>
							</em>
					} else {
						assid = "-";
						search = ""
					}
					just = value.just;
					injust = value.injust;
				}
				const td_obs = evall && evall.obs ? <em className="la la-info-circle" title={evall.obs} /> : "-";
				return [
					<td key={'a' + j}>{evall && evall.classification ? evall.classification : "-" }</td>,
					<td key={'b' + j}>{td_obs}</td>,
					<td key={'c' + j}>{just}</td>,
					<td key={'d' + j}>{injust}</td>,
					<td className='ht-separator right' key={'e' + j}>
					{ assid }
					{ search }
					</td>
				];
			});

			//percorrer os parâmetros de avaliação apra adicionar os trs correspondentes
			const trs = (module.eval_params && module.eval_params.expanded ? module.eval_params.params : []).map((param, k) => {
				const tds_evals = hp.store.trainees.map((trainee, m) => {
					const peval = param.evals ? param.evals[trainee.entity_code] : null;

					return [
						<td key={'m' + m} colSpan={2}>{peval ? peval.eval : '-'}</td>,
						<td className="ht-separator" key={'n' + m} colSpan={3}>{peval ? peval.weighing_factor : '-'}</td>
					];
				});
				return (
					<tr key={'k' + k}>
						<th style={{paddingLeft: '40px'}}>
							{param.name}
						</th>
						{tds_evals}
					</tr>
				);
			});
			trs.unshift(
				<tr key={i} rowSpan={module.eval_params && module.eval_params.expanded ? (module.eval_params.params.length + 1) : null} className={module.coursemodule_id == 0 ? 'footer' : null}>
					<th className="pointer" onClick={this.onExpand.bind(this, module)}>
						{module.coursemodule_id == 0 ? null :
							<em
								className={"fa fa-chevron-" + (module.eval_params && module.eval_params.expanded ? 'up' : 'down')}
								title={__('attrs_evaluation_parameter')}
							/>
						}
						<span>
							{module.module}
						</span>
					</th>
					{tds}

				</tr>
			);
			return trs
		})

		const head_details = []
		const head = hp.store.trainees.map((trainee, i) => {
			head_details.push(
				<th key={'a' + i} className="details">Nota</th>,
				<th key={'b' + i} className="details" title="Observações">Obs.</th>,
				<th key={'c' + i} className="details" title="Faltas justificadas">F.J.</th>,
				<th key={'d' + i} className="details" title="Faltas injustificadas">F.I.</th>,
				<th className="ht-separator details" key={'e' + i}>&#37;Assid.</th>
			)
			return (
				<th className='ht-separator' key={i} colSpan={5}>
					<div className="left item-center">
						<div>
							<img className="avatar" src={trainee.image} />
							{trainee.name}
						</div>
					</div>
				</th>
			)
		})
		head.unshift(<th className='center sticky-l ht-separator' key='m' rowSpan={2}>{__('attrs_coursemodule')}</th>)

		return (
			<div className='horizontal-table'>
				<table className='table sticky alternate'>
					<thead>
						<tr>{head}</tr>
						<tr>{head_details}</tr>
					</thead>
					<tbody>
						{table_body}
					</tbody>
				</table>
			</div>
		)
	}
}
